import { render } from "./ViewMandat.vue?vue&type=template&id=35f57e0e&scoped=true"
import script from "./ViewMandat.vue?vue&type=script&lang=js"
export * from "./ViewMandat.vue?vue&type=script&lang=js"

import "./ViewMandat.vue?vue&type=style&index=0&id=35f57e0e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f57e0e"]])

export default __exports__